import AmexGDAFeaturedCard from './AmexGDAFeaturedCard';

export default AmexGDAFeaturedCard;
